import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getStorage } from '../../utils/functions/localstorage';
import jwtDecode from 'jwt-decode';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import checkAccessRights from '../../utils/functions/accessRight';
import { ROLES } from '../../utils/constants';

function RejectedButton({ sendVelue, uploadRef, t }) {
  const otherReasonPlaceholders = [t('app.selectOther')];
  const [otherReason, setOtherReason] = useState('');
  const token = getStorage('token');
  const decoded = jwtDecode(token);
  const axios = require('axios');
  const { value: merchant, allMerchant } = useSelector(
    (state) => state.merchant,
  );
  const isAdminRole = checkAccessRights(ROLES.ADMIN_ROLE);
  const sorgcode = isAdminRole ? merchant || '' : allMerchant || '';

  const navigate = useNavigate();

  // 1. แก้ไข State เริ่มต้นให้ตรงกับ name ของ Checkbox ที่ใช้ในโค้ด
  const [reasons, setReasons] = useState({
    'รูปภาพไม่คมชัด': false,
    'รูปภาพไม่ถูกต้อง': false,
    'จำนวนเงินที่ชำระไม่ตรงตามใบแจ้งหนี้': false,
    'อื่นๆ': false,
  });

  const onCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setReasons((prevReasons) => ({
      ...prevReasons,
      [name]: checked,
    }));
    if (name === 'อื่นๆ') {
      setOtherReason(checked ? '' : null); 
    }
  };

  const onOtherReasonChange = (event) => {
    setOtherReason(event.target.value);
  };

  const onSubmit = async () => {
    const selectedReasons = Object.keys(reasons)
      .filter((key) => key !== 'อื่นๆ' && reasons[key])
      .map((key) => key);

    if (reasons['อื่นๆ'] && otherReason) {
      selectedReasons.push(`อื่นๆ : ${otherReason}`);
    }
    console.log('Selected Reasons:', selectedReasons);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_admin}/upload/reject-evidence`,
        {
          sorgcode: sendVelue?.sorgcode,
          orderIdRef: sendVelue?.transaction_ref,
          status: 'Reject',
          approver: decoded?.ONE_ID,
          reason: selectedReasons,
          upload_ref: uploadRef,
        },
      );

      Swal.fire({
        position: 'center',
        icon: 'success',
        title: t('app.rejectedSuccessfully'),
        showConfirmButton: false,
        timer: 3000,
      });

      navigate('/pending');
    } catch (error) {
      console.error('Error:', error.response?.data || error.message);
    }
  };

  // 2. เช็คว่ามี checkbox อย่างน้อย 1 อันที่ถูกติ๊กหรือไม่
  const isAnyCheckboxSelected = Object.values(reasons).some((isChecked) => isChecked);
  
  // 3. (ทางเลือกเพิ่มเติม) ถ้าติ๊ก "อื่นๆ" ควรบังคับให้พิมพ์ข้อความด้วย ถึงจะกดยืนยันได้
  const isOtherValid = reasons['อื่นๆ'] ? otherReason !== null && otherReason.trim() !== '' : true;

  // 4. ปุ่มจะถูก Disable ถ้าไม่มีการติ๊กเลย หรือ ติ๊กอื่นๆแต่ยังไม่พิมพ์ข้อความ
  const isSubmitDisabled = !isAnyCheckboxSelected || !isOtherValid;

  return (
    <div>
      <div className="mt-10 ">{t('app.rejectReason')}</div>
      <div>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={reasons['รูปภาพไม่คมชัด']}
                onChange={onCheckboxChange}
                name="รูปภาพไม่คมชัด"
                sx={{
                  '&.Mui-checked': {
                    color: 'red',
                  },
                }}
              />
            }
            label={t('app.imageUnclear')}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={reasons['รูปภาพไม่ถูกต้อง']}
                onChange={onCheckboxChange}
                name="รูปภาพไม่ถูกต้อง"
                sx={{
                  '&.Mui-checked': {
                    color: 'red',
                  },
                }}
              />
            }
            label={t('app.wrongDocument')}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={reasons['จำนวนเงินที่ชำระไม่ตรงตามใบแจ้งหนี้']}
                onChange={onCheckboxChange}
                name="จำนวนเงินที่ชำระไม่ตรงตามใบแจ้งหนี้"
                sx={{
                  '&.Mui-checked': {
                    color: 'red',
                  },
                }}
              />
            }
            label={t('app.amountMismatchInvoice')}
          />

          <Grid container alignItems="center">
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={reasons['อื่นๆ']} // เพิ่ม checked ตรงนี้ด้วยเพื่อความสมบูรณ์
                    onChange={onCheckboxChange}
                    name="อื่นๆ"
                    sx={{
                      '&.Mui-checked': {
                        color: 'red',
                      },
                    }}
                  />
                }
                label={t('app.other')}
              />
            </Grid>
            <Grid item xs>
              <TextField
                placeholder={
                  reasons['อื่นๆ']
                    ? otherReasonPlaceholders[1]
                    : otherReasonPlaceholders[0]
                }
                variant="standard"
                value={otherReason || ''} // กัน error กรณีค่าเป็น null
                onChange={onOtherReasonChange}
                fullWidth
                disabled={!reasons['อื่นๆ']}
              />
            </Grid>
          </Grid>
        </FormGroup>
      </div>

      <div className="flex justify-center mt-5">
        <Button
          variant="contained"
          sx={{ width: '400px' }}
          color="error"
          onClick={onSubmit}
          disabled={isSubmitDisabled} // 5. ใส่เงื่อนไข Disable ที่นี่
        >
          {t('app.reject')}
        </Button>
      </div>
    </div>
  );
}

export default RejectedButton;